import { render, staticRenderFns } from "./StudentDocInfoEducation.vue?vue&type=template&id=3ae60eb1&scoped=true&"
import script from "./StudentDocInfoEducation.vue?vue&type=script&lang=ts&"
export * from "./StudentDocInfoEducation.vue?vue&type=script&lang=ts&"
import style0 from "./StudentDocInfoEducation.vue?vue&type=style&index=0&id=3ae60eb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae60eb1",
  null
  
)

export default component.exports